export const TableColumn = ({ children, className }) => (
    <th className={`px-6 py-3 text-xs font-bold text-left text-gray-500 uppercase ${className}`}>
      <span className="inline-flex items-center">
        {children}
      </span>
    </th>
  );